<template>
  <td>
    <slot />
  </td>
</template>
<script setup lang="ts"></script>
<style scoped lang="scss">
@use 'src/design-system/design-tokens/font-mixins.scss';
@use 'src/design-system/design-tokens/variables.scss';
td {
  align-items: center;
  color: variables.$color-greyscale-content;
  display: flex;
  gap: 8px;
  justify-content: flex-start;
  text-overflow: ellipsis;
  white-space: nowrap;
  @include font-mixins.desktop-regular-paragraph;
}
</style>
